import AddIcon from "@mui/icons-material/Add";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useLoaderData, useNavigate, useNavigation } from "react-router-dom";
import { assignmentPeriodsColumns } from "./columns";
import useDataGridPaging from "../../app/useDataGridPaging";

export default function AssignmentPeriodsDataGrid() {
  const data = useLoaderData() as any;
  const navigation = useNavigation();
  const navigate = useNavigate();
  const {
    handlePaginationModelChange,
    handleSortModelChange,
    paginationModel,
    sortModel,
    handleFilterChange,
    filterModel,
  } = useDataGridPaging(data);
  return (
    <>
      <DataGrid
        autoHeight
        sx={{ width: "100%" }}
        rows={data.data}
        getRowId={(row) => row.assignmentPeriodCode}
        columns={assignmentPeriodsColumns}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
        }
        paginationModel={paginationModel}
        loading={navigation.state === "loading"}
        rowCount={data.totalCount}
        paginationMode="server"
        sortingMode="server"
        filterMode="server"
        filterModel={filterModel}
        pageSizeOptions={[3, 10, 20, 50, 100]}
        disableColumnResize
        onSortModelChange={handleSortModelChange}
        onPaginationModelChange={handlePaginationModelChange}
        sortModel={sortModel}
        onFilterModelChange={handleFilterChange}
        density="compact"
        slotProps={{
          filterPanel: {
            filterFormProps: {
              logicOperatorInputProps: {
                variant: "outlined",
                size: "small",
              },
              columnInputProps: {
                variant: "outlined",
                size: "small",
                sx: { mt: "auto" },
              },
              operatorInputProps: {
                variant: "outlined",
                size: "small",
                sx: { mt: "auto" },
              },
              valueInputProps: {
                InputComponentProps: {
                  variant: "outlined",
                  size: "small",
                },
              },
            },
          },
        }}
      />
      <SpeedDial
        ariaLabel="SpeedDial basic example"
        sx={{ position: "absolute", bottom: 16, right: 16 }}
        icon={<SpeedDialIcon />}
      >
        <SpeedDialAction
          icon={<AddIcon />}
          tooltipTitle={"Yeni"}
          onClick={() => navigate("new")}
        />
      </SpeedDial>
    </>
  );
}
